module.exports = __webpack_public_path__ + "assets/img/jianxia_score-77d37623.png";